import { _Componentes_WebApiCalls_Post } from "../ComponentesGlobales/WebApiCalls";

const post = (accion, request, opciones) =>
  _Componentes_WebApiCalls_Post(`Cajas/${accion}`, request, { preservarDatosConError: true, ...opciones });

export const listarCajas = (request, opciones) => post("Listar", request, opciones);
export const obtenerCaja = (request, opciones) => post("Get", request, opciones);
export const crearCaja = (request, opciones) => post("Crear", request, opciones);
export const modificarCaja = (request, opciones) => post("Modificar", request, opciones);
export const resolverCajaApi = (request, opciones) => post("Resolver", request, opciones);
export const abrirCajaApi = (request, opciones) => post("Abrir", request, opciones);
export const listarOperadoresDisponiblesCaja = (request, opciones) => post("OperadoresDisponibles", request, opciones);
export const agregarOperadorCaja = (request, opciones) => post("AgregarOperador", request, opciones);
export const quitarOperadorCaja = (request, opciones) => post("QuitarOperador", request, opciones);
export const registrarMovimientoCaja = (request, opciones) => post("Movimiento", request, opciones);
export const obtenerResumenCaja = (request, opciones) => post("Resumen", request, opciones);
export const cerrarCajaApi = (request, opciones) => post("Cerrar", request, opciones);
export const obtenerHistorialCajas = (request, opciones) => post("Historial", request, opciones);
export const obtenerReporteCaja = (request, opciones) =>
  _Componentes_WebApiCalls_Post("PISeunReportes/Caja", request, { preservarDatosConError: true, ...opciones });
export const listarCajasReporte = (request, opciones) =>
  _Componentes_WebApiCalls_Post("PISeunReportes/Cajas", request, { preservarDatosConError: true, ...opciones });
export const listarFormasPagoCaja = (request, opciones) => post("FormasPago", request, opciones);
export const configurarFormaPagoCaja = (request, opciones) => post("ConfigurarFormaPago", request, opciones);
